import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { IICRoutingModule } from './institute-industry-connect-routing.module';
import { IicListComponent } from './iic-list/iic-list.component';
import { IicCreateComponent } from './iic-create/iic-create.component';

@NgModule({
  declarations: [IicListComponent, IicCreateComponent],
  imports: [
    CommonModule,
    IICRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class IICModule { }
